<template>
  <v-card flat>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title class="pt-6 mt-6">
        <span class="headline">Godkänn betalningsansvar åt företaget</span>
      </v-card-title>

      <v-card-text>
        <v-row></v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn color="secondary" @click="showDialog" :disabled="!approveEnabled || !canUpdate">
          <v-icon>$sl-check</v-icon>
          Godkänn
        </v-btn>
      </v-card-actions>
      <v-card-title class="pt-6 mt-6">
        <span class="headline">Raderade beställningar går inte att återställa</span>
      </v-card-title>

      <v-card-text>
        <v-row></v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn color="secondary" @click="clickDelete" :disabled="!canDelete">
          <v-icon>$sl-delete</v-icon>
          Radera beställning
        </v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog persistent max-width="700px" v-model="visible">
      <v-card>
        <v-form ref="form" :lazy-validation="true">
          <v-card-title>
            <h4>Godkänn betalningsansvar</h4>
            <v-card-actions>
              <v-icon class="close" @click="close()">$sl-close</v-icon>
            </v-card-actions>
          </v-card-title>

          <v-card-text>
            <div class="sub-title">Godkänn betalningsansvar åt företaget</div>

            <v-spacer />

            <v-date-picker
                label="Datum för godkännande"
                v-model="date"
                clearable
            >
            </v-date-picker>
          </v-card-text>

          <v-card-actions class="d-flex justify-start">
            <v-btn outlined @click="close()">
              <v-icon>$sl-cancel</v-icon>
              Avbryt
            </v-btn>
            <v-btn @click="approve">
              <v-icon>$sl-check</v-icon>
              Godkänn
            </v-btn>
          </v-card-actions>

        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from "vuex";
import {CanIDo} from '@/components/mixins'
import get from 'lodash/get';

// @group Order
// OrderDelete component
export default {
  name: 'OrderDelete',
  mixins: [CanIDo],
  props: {
    //has id
    id: {
      // `Number`
      type: Number,
      // The default value is: `0`
      default: 0
    }
  },

  data: () => ({
    isLoading: false,
    date: null,
    visible: false,
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('order', ['selectedOrder']),

    isAdmin() {
      return get(this, 'currentUser.userrole.isAdmin', false)
    },

    approveEnabled() {
      console.log(this.selectedOrder);
      return !this.selectedOrder.approvedByCompanyAt && !this.selectedOrder.approvedById && this.isAdmin;
    }
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('order', 'delete');
    },
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    ...mapActions('order', ['setSelectedOrder']),
    // @vuese
    //- Used to delete distance order
    // @arg the argument is integer that represent distance order id
    async clickDelete() {
      if (!(this.id || this.id < 0)) {
        return
      }
      const res = await this.$dialog.confirm({
        title: 'Radering av beställning går inte att ångra.',
        text: 'Vill du ta radera beställningen?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res) {
        this.isLoading = true
        API.deleteDistanceOrder(this.id)
            .then(response => {
              this.$events.fire('showInfo', 'Beställningen raderad.')
              setTimeout(() => {
                this.$nextTick(() => this.$router.push({name: 'Orders'}))
              }, 2000)
            })
            .catch(error => {
              this.$events.fire('showError', 'Tyvärr gick det inte att radera denna beställning.')
              console.log(error)
            })
            .finally(() => {
              this.isLoading = false
            })
      } else {
        return
      }
    },
    close() {
      this.visible = false;
    },
    showDialog() {
      this.visible = true;
    },
    async approve() {
      this.isLoading = true;

      try {
        await API.updateDistanceOrder(this.$route.params.id, { data: { approvedByCompanyAt: this.date, approvedById: this.currentUser.id, stateId: this.selectedOrder.stateId > 2 ? undefined : 2 } })
        const res = await API.getDistanceOrder(this.$route.params.id);
        this.setSelectedOrder(res.data)
        this.$events.fire('showInfo', 'Sparad.')
      } finally {
        this.isLoading = false;
        this.visible = false;
      }
    }
  }
}
</script>
<style lang="scss">
.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  line-height: 1.6;
}
</style>
